<template>
  <div>
    <h1 class="common__main-title">Tutor Commuting Route Registration</h1>
    <div class="common__sub-title">
      <span>Details</span>
      <span class="common__sub-title-tag">Update</span>
    </div>
    <div class="common__main-contener">
      <div class="common__main-content bg-white mb-5">
        <div
          class="detail-table"
          v-for="(traffic, index) in traffics"
          :key="traffic.transportationExpenseId"
        >
          <h2 class="font-weight-bold mb-4">Route{{index + 1}}</h2>
          <div class="form-group">
            <label>University/Campus</label>
            <div class="ml-2">{{traffic.campus.name}}</div>
          </div>
          <div class="form-group">
            <label>Transportation Cost (One-Way)</label>
            <div class="ml-2">{{traffic.fee}}</div>
          </div>
          <div class="form-group">
            <label>Commuting Time (minutes)</label>
            <div class="ml-2">{{traffic.commutingTime}}</div>
          </div>
          <div class="form-group">
            <label>Nearest Station</label>
            <div class="ml-2">{{traffic.nearestStation}}</div>
          </div>
          <div class="form-group">
            <label>Period of Use</label>
            <div class="ml-2">
              <span>{{ traffic.validityDateFrom | ymd }}</span>
              <span class="ml-1 mr-1">～</span>
              <span>{{ traffic.validityDateTo | ymd }}</span>
            </div>
          </div>
          <div class="form-group">
            <label>Commuting Route</label>
            <div class="ml-2">{{traffic.route}}</div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <b-button
          pill
          variant="secondary"
          :to="{
            name:'TutorEditTraffic',
            params: { changeTraffic: this.$route.params.changeTraffic }
          }"
        >
          Back
        </b-button>
        <b-button
          pill
          variant="primary"
          v-if="traffics"
          @click="editTraffic"
        >
          Edit
        </b-button>
      </div>
    </div>
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script>
/* eslint-disable */
import LinkButton from '@/components/parts/LinkButton.vue';
import Loading from '@/components/parts/modal/Loading.vue';
import moment from 'moment';

export default {
  data() {
    return {
      traffics: this.$route.params.changeTraffic,
      isLoading: false,
    };
  },

  components: {
    LinkButton,
    Loading,
  },

  filters: {
    ymd(date) {
      return moment(date).format('YYYY/MM/DD')
    },
  },

  methods: {
    /* 成功時の処理 */
    async editTraffic() {
      this.isLoading = true;

      try {
        // postリクエストを同期的に処理
        for (const postTraffic of this.$route.params.post) {
          await this.$store.dispatch(
            'registerTraffic',
            { postTraffic, tutorId: this.$route.params.id },
          )
        }

        // putリクエストを同期的に処理
        for (const changeTraffic of this.$route.params.put) {
          await this.$store.dispatch(
            'changeTraffic',
            { changeTraffic, tutorId: this.$route.params.id },
          )
        }

        // deleteリクエストを同期的に処理
        for (const deleteTraffic of this.$route.params.delete) {
          await this.$store.dispatch(
            'deleteTraffic',
            { deleteTraffic, tutorId: this.$route.params.id },
          )
        }

        this.isLoading = false;
        await this.$bvModal.msgBoxOk('Success !')
        this.$router.push({ name: 'TutorDetail' })
      } catch (error) {
        this.isLoading = false;
        let message = error
        if (_.has(error, 'response')) {
          const { response } = error
          message = response.data.message
        }
        await this.$bvModal.msgBoxOk(`Error: ${message}`)
        this.$router.push({ name: 'TutorDetail' })
      }
    },

    confirmSave(event) {
      event.returnValue = "Data you've inputted won't be synced";
    },
  },
};
</script>
